export const GET_INVOKE = 'GET_INVOKE';
export const POST_INVOKE = 'POST_INVOKE';
export const SET_INVOKE = 'SET_INVOKE';
export const ERROR_INVOKE = 'ERROR_INVOKE';